import { actionTypes as resourceActions } from 'redux-resource';
import * as types from './types';

/*
 * create actions
 */
export const arrangePayment = (purchaseId, attrs) => ({
  type: types.ARRANGE_PAYMENT,
  payload: {
    purchaseId,
    attrs,
  }
});

const arrangePaymentDefaults = {
  requestKey: 'arrangePayment',
  resourceType: 'purchases',
}

export const arrangePaymentPending = () => ({
  ...arrangePaymentDefaults,
  type: resourceActions.UPDATE_RESOURCES_PENDING
});

export const arrangePaymentSucceeded = (response) => ({
  ...arrangePaymentDefaults,
  type: resourceActions.UPDATE_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const arrangePaymentFailed = () => ({
  ...arrangePaymentDefaults,
  type: resourceActions.UPDATE_RESOURCES_FAILED,
});